import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from "@/components/ui/drawer";
import { LoginForm } from "./LoginForm";

type AuthDrawerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function AuthDrawer({ open, onOpenChange }: AuthDrawerProps) {
  return (
    <Drawer fixed repositionInputs={false} open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="max-h-[88vh] overflow-y-auto rounded-t-[22px] border-white/70 bg-white dark:border-white/10 dark:bg-neutral-950">
        <DrawerTitle className="sr-only">Sign in to Zapify</DrawerTitle>
        <div className="px-3 pb-4 pt-3">
          <LoginForm surface="drawer" />
        </div>
      </DrawerContent>
    </Drawer>
  );
}
